import React from 'react'
import { useHistory } from 'react-router-dom'
import { Box } from 'components/Layout'
import { DEVICE } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { RequestResetPasswordCard } from 'sharedComponents/RequestResetPasswordCard'

const RequestResetPassword: React.VFC = () => {
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const history = useHistory()

  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems={!isMobile ? 'center' : undefined}
    >
      <RequestResetPasswordCard
        title="Request reset password"
        emailLabel="Email"
        emailPlaceholder="Enter your email"
        requestResetPasswordButtonLabel="Request change"
        signInButtonLabel="Sign in"
        onSignInButtonClick={() => history.push('/')}
      />
    </Box>
  )
}

export { RequestResetPassword }
